<template>
  <div class="sidebar"
       :data-color="backgroundColor"
       :data-active-color="activeColor"
       >
       
    <!-- <div class="logo">
      <a class="simple-text logo-mini"
         aria-label="sidebar mini logo"
         href="https://www.creative-tim.com/product/vue-paper-dashboard-2-pro">
          <div class="logo-img">
              <img :src="logo" alt="">
          </div>
      </a>
      <a class="simple-text logo-normal"
         href="https://www.creative-tim.com/vue-paper-dashboard-2-pro">
          {{ title }}
      </a>
    </div> -->
    <!-- Admin Header (User Block) -->
    <div class="admin-sidebar-header">
      <slot>

      </slot>
    </div>
    
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
      
      <!-- Admin Footer -->
      <div class="admin-sidebar-footer">
        <div class="version-info">
          <div class="logo-mini">
            <img src="/static/img/central-gym150x150.webp" alt="CentralGym" />
          </div>
          <div class="version-text">
            <p class="brand-name">CentralGym Admin</p>
            <p class="version-number">{{ appVersion }} {{ appEnv }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import 'perfect-scrollbar/css/perfect-scrollbar.css'
  import PerfectScrollbar from 'perfect-scrollbar';
  
  export default {
    props: {
      title: {
        type: String,
        default: 'CentralGym-OPS',
        description: 'Sidebar title'
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar background color (white|brown|black)'
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar active text color (primary|info|success|warning|danger)'
      },
      logo: {
        type: String,
        default: 'static/img/central-gym50x50.webp',
        description: 'Sidebar Logo'
      },
      sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },
      autoClose: {
        type: Boolean,
        default: false
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      }
    },
    computed: {
      appVersion() {
        return this.$store.state.appVersion;
      },
      appEnv() {
        return this.$store.state.appEnv;
      }
    },
    methods: {
      async initScrollBarAsync () {
        let isWindows = navigator.platform.startsWith('Win');
        if(!isWindows) {
          return;
        }
        // const PerfectScroll = await import('perfect-scrollbar')
        new PerfectScrollbar(this.$refs.sidebarScrollArea)
      }
    },
    mounted () {
      this.initScrollBarAsync()
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style lang="scss" scoped>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }

  /* Admin Header Styles */
  .admin-sidebar-header {
    padding: 15px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    background: rgba(0,0,0,0.15);
    flex-shrink: 0;
    min-height: 80px;
    position: relative;
    z-index: 10;
    overflow: visible;
  }
  
  /* Header en sidebar minimizado */
  .sidebar-mini .admin-sidebar-header {
    padding: 15px 0;
    min-height: auto;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    z-index: 100;
    overflow: visible;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
  }
  
  /* Expansión del header cuando el sidebar está en hover */
  .sidebar-mini .sidebar:hover .admin-sidebar-header {
    min-height: 180px;
    width: 170px;
    padding: 15px 12px 25px 12px;
    background: rgba(0,0,0,0.25);
    border-radius: 0 15px 15px 0;
    box-shadow: 4px 0 20px rgba(0,0,0,0.3);
    margin-left: 0;
    left: 0;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* Admin Footer Styles */
  .admin-sidebar-footer {
    padding: 12px 15px;
    border-top: 1px solid rgba(255,255,255,0.1);
    background: rgba(0,0,0,0.15);
    margin-top: auto;
    flex-shrink: 0;
    min-height: 60px;
    position: relative;
    z-index: 10;
    
    .version-info {
      display: flex;
      align-items: center;
      
      .logo-mini {
        margin-right: 10px;
        flex-shrink: 0;
        
        img {
          width: 32px;
          height: 32px;
          border-radius: 6px;
          object-fit: contain;
          background: rgba(255,255,255,0.1);
          padding: 2px;
        }
      }
      
      .version-text {
        flex: 1;
        min-width: 0;
        
        .brand-name {
          color: white;
          font-size: 12px;
          font-weight: 600;
          margin: 0 0 2px 0;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          line-height: 1.2;
        }
        
        .version-number {
          color: rgba(255,255,255,0.6);
          font-size: 10px;
          margin: 0;
          font-weight: 400;
          line-height: 1.2;
        }
      }
    }
  }

  /* Sidebar layout adjustments */
  .sidebar {
    display: flex;
    flex-direction: column;
    height: 100vh;
    
    .sidebar-wrapper {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding-bottom: 0px !important;
      
      .nav {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        padding-bottom: 20px;
        
        /* Scrollbar personalizado para navegación */
        &::-webkit-scrollbar {
          width: 4px;
        }
        
        &::-webkit-scrollbar-track {
          background: transparent;
        }
        
        &::-webkit-scrollbar-thumb {
          background: rgba(255,255,255,0.2);
          border-radius: 2px;
          
          &:hover {
            background: rgba(255,255,255,0.4);
          }
        }
      }
    }
  }
  
  /* Responsive adjustments for admin footer */
  @media (max-width: 991px) {
    .admin-sidebar-footer {
      padding: 10px 12px;
      min-height: 50px;
      
      .version-text {
        .brand-name {
          font-size: 11px;
        }
        
        .version-number {
          font-size: 9px;
        }
      }
      
      .logo-mini img {
        width: 28px;
        height: 28px;
      }
    }
  }
  
  /* Sidebar minimizado */
  .sidebar.sidebar-mini {
    .admin-sidebar-footer {
      padding: 8px;
      text-align: center;
      
      .version-info {
        flex-direction: column;
        
        .logo-mini {
          margin: 0 0 5px 0;
          
          img {
            width: 24px;
            height: 24px;
          }
        }
        
        .version-text {
          display: none;
        }
      }
    }
  }
  
  /* Scrollbar general para sidebar */
  .sidebar-wrapper::-webkit-scrollbar {
    width: 6px;
  }
  
  .sidebar-wrapper::-webkit-scrollbar-track {
    background: transparent;
  }
  
  .sidebar-wrapper::-webkit-scrollbar-thumb {
    background: rgba(255,255,255,0.2);
    border-radius: 3px;
    
    &:hover {
      background: rgba(255,255,255,0.4);
    }
  }
  
  /* Override para el tema específico del sidebar */
  .sidebar[data-color="black"] {
    .admin-sidebar-header {
      background: rgba(0,0,0,0.3);
      border-bottom: 1px solid rgba(255,255,255,0.08);
    }
    
    .admin-sidebar-footer {
      background: rgba(0,0,0,0.3);
      border-top: 1px solid rgba(255,255,255,0.08);
    }
  }
  
  .sidebar[data-color="white"] {
    .admin-sidebar-header {
      background: rgba(0,0,0,0.05);
      border-bottom: 1px solid rgba(0,0,0,0.1);
    }
    
    .admin-sidebar-footer {
      background: rgba(0,0,0,0.05);
      border-top: 1px solid rgba(0,0,0,0.1);
      
      .version-text {
        .brand-name {
          color: #333;
        }
        
        .version-number {
          color: rgba(0,0,0,0.6);
        }
      }
    }
  }
</style>
